import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

//引入页面组件
import Index from "@/views/index.vue";

  
//配置路由与页面组件的关系
const routes = [
  { path: "/", component: Index },  
];

// 防止连续点击多次路由报错
let routerPush = Router.prototype.push
let routerReplace = Router.prototype.replace
// push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(err => err)
}
// replace
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch(err => err)
}

export default new Router({
  mode: 'history', // 去掉url中的#
  scrollBehavior: () => ({ y: 0 }),
  routes: routes
})